import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Chip
} from '@mui/material';

export default function CuponesClienteTabla({ cupones }) {
  return (
    <Box sx={{ mt: 1 }}>
      {!cupones || cupones.length === 0 ? (
        <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic', py: 2 }}>
          No hay cupones registrados para este cliente.
        </Typography>
      ) : (
        <Box sx={{ overflowX: 'auto', border: '1px solid #E2E8F0', borderRadius: '8px' }}>
          <Table size="small">
            <TableHead sx={{ backgroundColor: '#0F172A' }}>
              <TableRow>
                <TableCell sx={{ color: '#FFF', fontWeight: 'bold' }}>Código</TableCell>
                <TableCell sx={{ color: '#FFF', fontWeight: 'bold' }}>Concepto / Descripción</TableCell>
                <TableCell sx={{ color: '#FFF', fontWeight: 'bold', textAlign: 'right' }}>Importe (€)</TableCell>
                <TableCell sx={{ color: '#FFF', fontWeight: 'bold', textAlign: 'center' }}>Estado</TableCell>
                <TableCell sx={{ color: '#FFF', fontWeight: 'bold' }}>Fecha Asignación</TableCell>
                <TableCell sx={{ color: '#FFF', fontWeight: 'bold' }}>Fecha Uso</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cupones.map((c) => {
                const esDisponible = c.estado === 'DISPONIBLE' || c.estado === 'ACTIVO';
                return (
                  <TableRow key={c.id} hover sx={{ '&:nth-of-type(even)': { backgroundColor: '#F8FAFC' } }}>
                    <TableCell sx={{ fontWeight: 'bold', color: '#2563EB' }}>{c.codigo}</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>{c.concepto || c.titulo || 'Cupón'}</TableCell>
                    <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', color: '#0F172A' }}>
                      {c.importe ? `${parseFloat(c.importe).toFixed(2)} €` : '0.00 €'}
                    </TableCell>
                    <TableCell sx={{ textAlign: 'center' }}>
                      <Chip
                        label={esDisponible ? 'DISPONIBLE' : 'USADO'}
                        color={esDisponible ? 'success' : 'default'}
                        size="small"
                        sx={{ fontWeight: 'bold', fontSize: '11px' }}
                      />
                    </TableCell>
                    <TableCell>{c.fecha_compra || '-'}</TableCell>
                    <TableCell>{c.fecha_uso || '-'}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      )}
    </Box>
  );
}
